import React from 'react';
import { Flex, LinkV2 } from '@withjoy/joykit';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { ResponsiveMarginProps } from '@withjoy/joykit/styled-system';

const joyLogoProps = {
  height: 24,
  width: 38,
  color: '#333333',
};

interface FooterProps extends ResponsiveMarginProps {}

export const Footer: React.FC<FooterProps> = ({ ...props }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    columnGap="32px"
    {...props}
  >
    <LinkV2
      typographyVariant="body1"
      color="mono10"
      textDecoration="none"
      target="_blank"
      href="http://help.withjoy.com/guest-help/?utm_source=rsvp-page&utm_medium=viral&utm_campaign=guest-help"
    >
      Help
    </LinkV2>
    <LinkV2
      height="24px"
      width="38px"
      textDecoration="none"
      target="_blank"
      href="https://withjoy.com?utm_source=viral&utm_medium=guestSite&utm_campaign=rsvp"
      aria-label="Joy Home Page"
    >
      <JoyLogo {...joyLogoProps} />
    </LinkV2>
    <LinkV2
      typographyVariant="body1"
      color="mono10"
      textDecoration="none"
      target="_blank"
      href="https://withjoy.com/?utm_source=viral&utm_medium=guestSite&utm_campaign=rsvp"
    >
      About
    </LinkV2>
  </Flex>
);
